import React, { useEffect, useState } from "react";
import EditableField from "../components/EditableField";
import axios from "axios";

const Transactions = () => {
  const [websiteConfig, setWebsiteConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Editing states
  const [editingMinUsdtDeposit, setEditingMinUsdtDeposit] = useState(false);
  const [tempMinUsdtDeposit, setTempMinUsdtDeposit] = useState("");

  const [editingMinManualDeposit, setEditingMinManualDeposit] = useState(false);
  const [tempMinManualDeposit, setTempMinManualDeposit] = useState("");

  const [editingMinBankDeposit, setEditingMinBankDeposit] = useState(false);
  const [tempMinBankDeposit, setTempMinBankDeposit] = useState("");

  const [editingMinUpiDeposit, setEditingMinUpiDeposit] = useState(false);
  const [tempMinUpiDeposit, setTempMinUpiDeposit] = useState("");

  const [editingMinPaytmDeposit, setEditingMinPaytmDeposit] = useState(false);
  const [tempMinPaytmDeposit, setTempMinPaytmDeposit] = useState("");

  const [editingMinPhonepeDeposit, setEditingMinPhonepeDeposit] =
    useState(false);
  const [tempMinPhonepeDeposit, setTempMinPhonepeDeposit] = useState("");

  const [editingMaxUsdtDeposit, setEditingMaxUsdtDeposit] = useState(false);
  const [tempMaxUsdtDeposit, setTempMaxUsdtDeposit] = useState("");

  const [editingMaxManualDeposit, setEditingMaxManualDeposit] = useState(false);
  const [tempMaxManualDeposit, setTempMaxManualDeposit] = useState("");

  const [editingMaxBankDeposit, setEditingMaxBankDeposit] = useState(false);
  const [tempMaxBankDeposit, setTempMaxBankDeposit] = useState("");

  const [editingMaxPhonepeDeposit, setEditingMaxPhonepeDeposit] =
    useState(false);
  const [tempMaxPhonepeDeposit, setTempMaxPhonepeDeposit] = useState("");

  const [editingMaxPaytmDeposit, setEditingMaxPaytmDeposit] = useState(false);
  const [tempMaxPaytmDeposit, setTempMaxPaytmDeposit] = useState("");

  const [editingMaxUpiDeposit, setEditingMaxUpiDeposit] = useState(false);
  const [tempMaxUpiDeposit, setTempMaxUpiDeposit] = useState("");

  const [editingMinWithdrawal, setEditingMinWithdrawal] = useState(false);
  const [tempMinWithdrawal, setTempMinWithdrawal] = useState("");

  const [editingMaxWithdrawal, setEditingMaxWithdrawal] = useState(false);
  const [tempMaxWithdrawal, setTempMaxWithdrawal] = useState("");

  const [editingMinUsdtToGetSpin, setEditingMinUsdtToGetSpin] = useState(false);
  const [tempMinUsdtToGetSpin, setTempMinUsdtToGetSpin] = useState("");

  const [editingUsdtRate, setEditingUsdtRate] = useState(false);
  const [tempUsdtRate, setTempUsdtRate] = useState("");

  const apiUrl = "https://api.trubetx.com/admin/websiteconfig";

  const fetchWebsiteConfig = async () => {
    try {
      const response = await axios.get(apiUrl);
      setWebsiteConfig(response?.data?.data?.websiteConfig);

      setTempMinUsdtDeposit(response.data.deposit_usdt_min || "");
      setTempMaxUsdtDeposit(response.data.deposit_usdt_min || "");

      setTempMinManualDeposit(response.data.deposit_manual_min || "");
      setTempMaxManualDeposit(response.data.deposit_manual_min || "");

      setTempMinUpiDeposit(response.data.deposit_upi_min || "");
      setTempMaxUpiDeposit(response.data.deposit_upi_min || "");

      setTempMinBankDeposit(response.data.deposit_bank_min || "");
      setTempMaxBankDeposit(response.data.deposit_bank_min || "");

      setTempMinPhonepeDeposit(response.data.deposit_phonepe_min || "");
      setTempMaxPhonepeDeposit(response.data.deposit_phonepe_max || "");

      setTempMinPaytmDeposit(response.data.deposit_paytm_min || "");
      setTempMaxPaytmDeposit(response.data.deposit_paytm_min || "");

      setTempMinWithdrawal(response.data.minimum_withdrawal || "");
      setTempMaxWithdrawal(response.data.maximum_withdrawal || "");

      setTempMinUsdtToGetSpin(response.data.min_usdt_deposit_to_get_spin || "");

      setTempUsdtRate(response.data.usdt_rate || "");
    } catch (err) {
      console.error("Failed to fetch website config:", err);
      setError("Failed to load website configuration.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWebsiteConfig();
  }, []);

  const handleEdit = (setEditing, setTempValue, value) => {
    setEditing(true);
    setTempValue(value);
  };

  const handleCancel = (setEditing, setTempValue, value) => {
    setEditing(false);
    setTempValue(value);
  };

  const saveWebsiteConfigField = async (
    field,
    value,
    setEditing,
    setTempValue
  ) => {
    try {
      await axios.post(`https://api.trubetx.com/admin/updatewebsiteconfig`, {
        website_config_deposit_withdrawal: true,
        [field]: value,
      });
      setWebsiteConfig((prev) => ({
        ...prev,
        [field]: value,
      }));
      setEditing(false);
      setTempValue("");
      setError(null);
    } catch (error) {
      console.error("Failed to save website config field:", error);
      setError("Failed to save changes.");
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <div className="gap grid rounded-lg">
      <div className="bg-white">
        <p className="border-y bg-gray-50 px-3 py-3 text-base font-bold capitalize">
          Manual Upi Deposit
        </p>
        <div className="grid gap-5 px-3 py-3 sm:grid-cols-2">
          <EditableField
            label="Minimum Manual Deposit"
            value={websiteConfig?.deposit_manual_min || ""}
            editing={editingMinManualDeposit}
            tempValue={tempMinManualDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMinManualDeposit,
                setTempMinManualDeposit,
                websiteConfig?.deposit_manual_min || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMinManualDeposit,
                setTempMinManualDeposit,
                websiteConfig?.deposit_manual_min || ""
              )
            }
            onChange={(e) => setTempMinManualDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "minimum_manual_deposit",
                tempMinManualDeposit,
                setEditingMinManualDeposit,
                setTempMinManualDeposit
              )
            }
          />
          <EditableField
            label="Maximum Manual Deposit"
            value={websiteConfig?.deposit_manual_max || ""}
            editing={editingMaxManualDeposit}
            tempValue={tempMaxManualDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMaxManualDeposit,
                setTempMaxManualDeposit,
                websiteConfig?.deposit_manual_max || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMaxManualDeposit,
                setTempMaxManualDeposit,
                websiteConfig?.deposit_manual_max || ""
              )
            }
            onChange={(e) => setTempMaxManualDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "maximum_manual_deposit",
                tempMaxManualDeposit,
                setEditingMaxManualDeposit,
                setTempMaxManualDeposit
              )
            }
          />
        </div>

        <p className="border-y bg-gray-50 px-3 py-3 text-base font-bold capitalize">
          Bank Deposit
        </p>
        <div className="grid gap-5 px-3 py-3 sm:grid-cols-2">
          <EditableField
            label="Minimum Bank Deposit"
            value={websiteConfig?.deposit_bank_min || ""}
            editing={editingMinBankDeposit}
            tempValue={tempMinBankDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMinBankDeposit,
                setTempMinBankDeposit,
                websiteConfig?.deposit_bank_min || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMinBankDeposit,
                setTempMinBankDeposit,
                websiteConfig?.deposit_bank_min || ""
              )
            }
            onChange={(e) => setTempMinBankDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "minimum_bank_deposit",
                tempMinBankDeposit,
                setEditingMinBankDeposit,
                setTempMinBankDeposit
              )
            }
          />
          <EditableField
            label="Maximum Bank Deposit"
            value={websiteConfig?.deposit_bank_max || ""}
            editing={editingMaxBankDeposit}
            tempValue={tempMaxBankDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMaxBankDeposit,
                setTempMaxBankDeposit,
                websiteConfig?.deposit_bank_max || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMaxBankDeposit,
                setTempMaxBankDeposit,
                websiteConfig?.deposit_bank_max || ""
              )
            }
            onChange={(e) => setTempMaxBankDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "maximum_bank_deposit",
                tempMaxBankDeposit,
                setEditingMaxBankDeposit,
                setTempMaxBankDeposit
              )
            }
          />
        </div>

        <p className="border-y bg-gray-50 px-3 py-3 text-base font-bold capitalize">
          Usdt Deposit
        </p>
        <div className="grid gap-5 px-3 py-3 sm:grid-cols-2">
          <EditableField
            label="Minimum Usdt Deposit"
            value={websiteConfig?.deposit_usdt_min || ""}
            editing={editingMinUsdtDeposit}
            tempValue={tempMinUsdtDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMinUsdtDeposit,
                setTempMinUsdtDeposit,
                websiteConfig?.deposit_usdt_min || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMinUsdtDeposit,
                setTempMinUsdtDeposit,
                websiteConfig?.deposit_usdt_min || ""
              )
            }
            onChange={(e) => setTempMinUsdtDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "minimum_Usdt_deposit",
                tempMinUsdtDeposit,
                setEditingMinUsdtDeposit,
                setTempMinUsdtDeposit
              )
            }
          />
          <EditableField
            label="Maximum Usdt Deposit"
            value={websiteConfig?.deposit_usdt_max || ""}
            editing={editingMaxUsdtDeposit}
            tempValue={tempMaxUsdtDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMaxUsdtDeposit,
                setTempMaxUsdtDeposit,
                websiteConfig?.deposit_usdt_max || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMaxUsdtDeposit,
                setTempMaxUsdtDeposit,
                websiteConfig?.deposit_usdt_max || ""
              )
            }
            onChange={(e) => setTempMaxUsdtDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "maximum_Usdt_deposit",
                tempMaxUsdtDeposit,
                setEditingMaxUsdtDeposit,
                setTempMaxUsdtDeposit
              )
            }
          />
        </div>

        <p className="border-y bg-gray-50 px-3 py-3 text-base font-bold capitalize">
          Usdt Deposit Settings
        </p>
        <div className="grid gap-5 px-3 py-3 sm:grid-cols-2">
          <EditableField
            label="Minimum Usdt Deposit to Get Free Spin"
            value={websiteConfig?.min_usdt_deposit_to_get_spin || ""}
            editing={editingMinUsdtToGetSpin}
            tempValue={tempMinUsdtToGetSpin}
            onEdit={() =>
              handleEdit(
                setEditingMinUsdtToGetSpin,
                setTempMinUsdtToGetSpin,
                websiteConfig?.min_usdt_deposit_to_get_spin || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMinUsdtToGetSpin,
                setTempMinUsdtToGetSpin,
                websiteConfig?.min_usdt_deposit_to_get_spin || ""
              )
            }
            onChange={(e) => setTempMinUsdtToGetSpin(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "minimum_usdt_deposit_to_get_spin",
                tempMinUsdtToGetSpin,
                setEditingMinUsdtToGetSpin,
                setTempMinUsdtToGetSpin
              )
            }
          />
          <EditableField
            label="Current Usdt Rate"
            value={websiteConfig?.usdt_rate || ""}
            editing={editingUsdtRate}
            tempValue={tempUsdtRate}
            onEdit={() =>
              handleEdit(
                setEditingUsdtRate,
                setTempUsdtRate,
                websiteConfig?.usdt_rate || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingUsdtRate,
                setTempUsdtRate,
                websiteConfig?.usdt_rate || ""
              )
            }
            onChange={(e) => setTempUsdtRate(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "UsdtRate",
                tempUsdtRate,
                setEditingUsdtRate,
                setTempUsdtRate
              )
            }
          />
        </div>

        <p className="border-y bg-gray-50 px-3 py-3 text-base font-bold capitalize">
          Phonepe Deposit
        </p>
        <div className="grid gap-5 px-3 py-3 sm:grid-cols-2">
          <EditableField
            label="Minimum Phonepe Deposit"
            value={websiteConfig?.deposit_phonepe_min || ""}
            editing={editingMinPhonepeDeposit}
            tempValue={tempMinPhonepeDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMinPhonepeDeposit,
                setTempMinPhonepeDeposit,
                websiteConfig?.deposit_phonepe_min || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMinPhonepeDeposit,
                setTempMinPhonepeDeposit,
                websiteConfig?.deposit_phonepe_min || ""
              )
            }
            onChange={(e) => setTempMinPhonepeDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "minimum_Phonepe_deposit",
                tempMinPhonepeDeposit,
                setEditingMinPhonepeDeposit,
                setTempMinPhonepeDeposit
              )
            }
          />
          <EditableField
            label="Maximum Phonepe Deposit"
            value={websiteConfig?.deposit_phonepe_max || ""}
            editing={editingMaxPhonepeDeposit}
            tempValue={tempMaxPhonepeDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMaxPhonepeDeposit,
                setTempMaxPhonepeDeposit,
                websiteConfig?.deposit_phonepe_max || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMaxPhonepeDeposit,
                setTempMaxPhonepeDeposit,
                websiteConfig?.deposit_phonepe_max || ""
              )
            }
            onChange={(e) => setTempMaxPhonepeDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "maximum_Phonepe_deposit",
                tempMaxPhonepeDeposit,
                setEditingMaxPhonepeDeposit,
                setTempMaxPhonepeDeposit
              )
            }
          />
        </div>

        <p className="border-y bg-gray-50 px-3 py-3 text-base font-bold capitalize">
          Paytm Deposit
        </p>
        <div className="grid gap-5 px-3 py-3 sm:grid-cols-2">
          <EditableField
            label="Minimum Paytm Deposit"
            value={websiteConfig?.deposit_paytm_min || ""}
            editing={editingMinPaytmDeposit}
            tempValue={tempMinPaytmDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMinPaytmDeposit,
                setTempMinPaytmDeposit,
                websiteConfig?.deposit_paytm_min || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMinPaytmDeposit,
                setTempMinPaytmDeposit,
                websiteConfig?.deposit_paytm_min || ""
              )
            }
            onChange={(e) => setTempMinPaytmDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "minimum_Paytm_deposit",
                tempMinPaytmDeposit,
                setEditingMinPaytmDeposit,
                setTempMinPaytmDeposit
              )
            }
          />
          <EditableField
            label="Maximum Paytm Deposit"
            value={websiteConfig?.deposit_paytm_max || ""}
            editing={editingMaxPaytmDeposit}
            tempValue={tempMaxPaytmDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMaxPaytmDeposit,
                setTempMaxPaytmDeposit,
                websiteConfig?.deposit_paytm_max || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMaxPaytmDeposit,
                setTempMaxPaytmDeposit,
                websiteConfig?.deposit_paytm_max || ""
              )
            }
            onChange={(e) => setTempMaxPaytmDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "maximum_Paytm_deposit",
                tempMaxPaytmDeposit,
                setEditingMaxPaytmDeposit,
                setTempMaxPaytmDeposit
              )
            }
          />
        </div>

        <p className="border-y bg-gray-50 px-3 py-3 text-base font-bold capitalize">
          Upi Deposit
        </p>
        <div className="grid gap-5 px-3 py-3 sm:grid-cols-2">
          <EditableField
            label="Minimum Upi Deposit"
            value={websiteConfig?.deposit_upi_min || ""}
            editing={editingMinUpiDeposit}
            tempValue={tempMinUpiDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMinUpiDeposit,
                setTempMinUpiDeposit,
                websiteConfig?.deposit_upi_min || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMinUpiDeposit,
                setTempMinUpiDeposit,
                websiteConfig?.deposit_upi_min || ""
              )
            }
            onChange={(e) => setTempMinUpiDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "minimum_Upi_deposit",
                tempMinUpiDeposit,
                setEditingMinUpiDeposit,
                setTempMinUpiDeposit
              )
            }
          />
          <EditableField
            label="Maximum Upi Deposit"
            value={websiteConfig?.deposit_upi_max || ""}
            editing={editingMaxUpiDeposit}
            tempValue={tempMaxUpiDeposit}
            onEdit={() =>
              handleEdit(
                setEditingMaxUpiDeposit,
                setTempMaxUpiDeposit,
                websiteConfig?.deposit_upi_max || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMaxUpiDeposit,
                setTempMaxUpiDeposit,
                websiteConfig?.deposit_upi_max || ""
              )
            }
            onChange={(e) => setTempMaxUpiDeposit(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "maximum_Upi_deposit",
                tempMaxUpiDeposit,
                setEditingMaxUpiDeposit,
                setTempMaxUpiDeposit
              )
            }
          />
        </div>

        <p className="border-y bg-gray-50 px-3 py-3 text-base font-bold capitalize">
          Withdrawal
        </p>
        <div className="grid gap-5 px-3 py-3 sm:grid-cols-2">
          <EditableField
            label="Minimum Withdrawal"
            value={websiteConfig?.minimum_withdrawal || ""}
            editing={editingMinWithdrawal}
            tempValue={tempMinWithdrawal}
            onEdit={() =>
              handleEdit(
                setEditingMinWithdrawal,
                setTempMinWithdrawal,
                websiteConfig?.minimum_withdrawal || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMinWithdrawal,
                setTempMinWithdrawal,
                websiteConfig?.minimum_withdrawal || ""
              )
            }
            onChange={(e) => setTempMinWithdrawal(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "minimum_withdrawal",
                tempMinWithdrawal,
                setEditingMinWithdrawal,
                setTempMinWithdrawal
              )
            }
          />
          <EditableField
            label="Maximum Withdrawal"
            value={websiteConfig?.maximum_withdrawal || ""}
            editing={editingMaxWithdrawal}
            tempValue={tempMaxWithdrawal}
            onEdit={() =>
              handleEdit(
                setEditingMaxWithdrawal,
                setTempMaxWithdrawal,
                websiteConfig?.maximum_withdrawal || ""
              )
            }
            onCancel={() =>
              handleCancel(
                setEditingMaxWithdrawal,
                setTempMaxWithdrawal,
                websiteConfig?.maximum_withdrawal || ""
              )
            }
            onChange={(e) => setTempMaxWithdrawal(e.target.value)}
            onSave={() =>
              saveWebsiteConfigField(
                "maximum_withdrawal",
                tempMaxWithdrawal,
                setEditingMaxWithdrawal,
                setTempMaxWithdrawal
              )
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Transactions;
